/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ReactNode } from 'react';

import { OAuth2Providers } from 'shared';

import { GitHubIcon } from './icons/GitHubIcon';
import { GoogleIcon } from './icons/GoogleIcon';
import { MicrosoftIcon } from './icons/MicrosoftIcon';

export const ssoIcons: Record<OAuth2Providers, ReactNode> = {
  github: <GitHubIcon />,
  google: <GoogleIcon />,
  microsoft: <MicrosoftIcon />,
};
